// DS: MO3.4.2
import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationShopCard, {
  type DeviationShopCardProps,
} from '../DeviationShopCard';

export interface Props
  extends Pick<DeviationShopCardProps, 'allowedIndicators'> {
  deviation: PapiDeviation;
  width: number;
  withAuthorDetails?: boolean;
  withDescriptionBlock?: boolean;
}

const CommissionShopCard: React.FC<Props> = ({
  width,
  deviation,
  withAuthorDetails,
  allowedIndicators,
  withDescriptionBlock = true,
}) => {
  return (
    <DeviationShopCard
      width={width}
      deviation={deviation}
      withStats={false}
      withDescriptionBlock={withDescriptionBlock}
      withAuthorDetails={withAuthorDetails}
      allowedIndicators={allowedIndicators}
    />
  );
};
CommissionShopCard.displayName = 'CommissionShopCard';

export default CommissionShopCard;
